<div class="rx-intuitive-implants-view-modal">
	<header class="rx-intuitive-implants-view-modal__masthead">
		<div class="rx-intuitive-implants-view-modal__title-row">
			<div class="rx-intuitive-implants-view-modal__title-row-start">
				<div class="rx-intuitive-implants-view-modal__tooth-line" role="heading" aria-level="2">
					{{ modalData.headerToothTitle }}
				</div>
				<span class="rx-intuitive-implants-view-modal__indication-badge">
					<rx-intuitive-indication-badge
						class="rx-intuitive-implants-view-modal__indication-embed"
						[indication]="indicationId"
						[iconOnly]="true"
					/>
					{{ 'UnitTypes.ImplantBased' | translate }}
				</span>
			</div>
		</div>
	</header>

	<rx-banner
		*ngIf="isReadOnly$ | async"
		class="rx-intuitive-implants-view-modal__read-only-banner"
		type="info"
		appearance="intuitive"
		[message]="'ReadOnlyMode.ReadOnlyMessage' | translate"
	></rx-banner>

	<tlk-modal-content class="tooth-editor-body">
		<div id="tooth-editor-body-container">
			<div class="implants-view-container">
				<rx-implants-view [appParameters]="implantsViewAppParameters$ | async"></rx-implants-view>
			</div>
			<div class="rx-intuitive-implants-view-modal__crown-accordion" *ngIf="shouldShowCrownSection">
				<ng-container *ngIf="restorationTypeData$ | async as restoration">
					<div
						id="rx-intuitive-implants-view-restoration-type-expansion-panel"
						class="rx-intuitive-implants-view-modal__expansion"
					>
						<button
							type="button"
							class="rx-expansion-header rx-intuitive-implants-view-modal__expansion-trigger"
							id="rx-intuitive-implants-view-restoration-type-panel-title"
							[attr.aria-expanded]="restorationTypeSectionExpanded"
							(click)="restorationTypeSectionExpanded = !restorationTypeSectionExpanded"
						>
							<span class="rx-intuitive-implants-view-modal__expansion-chevron" aria-hidden="true"></span>
							<span class="rx-intuitive-implants-view-modal__expansion-title">{{
								'ToothEditor.RestorationType' | translate
							}}</span>
						</button>
						<tlk-expansion-area [expanded]="restorationTypeSectionExpanded" [removeWhenCollapsed]="false">
							<ng-template tlkExpansionContent>
								<div class="rx-intuitive-implants-view-modal__expansion-panel-inner">
									<rx-restoration-type-section
										[ImplantBasedRestorationTypeId]="restoration.ImplantBasedRestorationTypeId"
										[AbutmentType]="restoration.AbutmentType"
										[AbutmentMaterialId]="restoration.AbutmentMaterialId"
										[isReadOnly]="isReadOnly$ | async"
										(restorationTypeChanged)="onRestorationTypeChanged($event)"
									/>
								</div>
							</ng-template>
						</tlk-expansion-area>
					</div>
				</ng-container>
				<ng-container *ngIf="crownFormData$ | async as crownForm">
					<div id="rx-intuitive-implants-view-crown-expansion-panel" class="rx-intuitive-implants-view-modal__expansion">
						<button
							type="button"
							class="rx-expansion-header rx-intuitive-implants-view-modal__expansion-trigger"
							id="rx-intuitive-implants-view-crown-expansion-panel-title"
							[attr.aria-expanded]="crownSectionExpanded"
							(click)="crownSectionExpanded = !crownSectionExpanded"
						>
							<span class="rx-intuitive-implants-view-modal__expansion-chevron" aria-hidden="true"></span>
							<span class="rx-intuitive-implants-view-modal__expansion-title">{{ 'ToothEditor.Crown' | translate }}</span>
						</button>
						<tlk-expansion-area [expanded]="crownSectionExpanded" [removeWhenCollapsed]="false">
							<ng-template tlkExpansionContent>
								<div class="rx-intuitive-implants-view-modal__crown-body">
									<rx-intuitive-crown
										[crownForm]="crownForm"
										[indicationId]="indicationId"
										[customLabMaterialGroup]="customLabMaterialGroup"
										[isBridge]="isBridge"
										[isReadOnly]="isReadOnly$ | async"
										(crownFormChanged)="onCrownFormChanged($event)"
										(selectionContext)="onCrownSelectionContext($event)"
									/>
									<button
										tlkButton
										variant="ghost"
										size="m"
										type="button"
										class="rx-intuitive-implants-view-modal__additional-info-btn"
										(click)="onAdditionalInfoClick()"
									>
										{{
											((hasAdditionalInfoButtonSaved$ | async)
												? 'ToothEditor.AdditionalInfoButtonSaved'
												: 'ToothEditor.AdditionalInfoButton'
											) | translate
										}}
									</button>
								</div>
							</ng-template>
						</tlk-expansion-area>
					</div>
				</ng-container>
			</div>
		</div>
	</tlk-modal-content>

	<tlk-modal-footer>
		<ng-container ngProjectAs="[left-buttons]">
			<div *ngIf="(isReadOnly$ | async) !== true" class="rx-intuitive-implants-view-modal__footer-actions">
				<button tlkButton variant="danger" size="m" type="button" (click)="handleDelete()">
					{{ 'ToothEditor.Delete' | translate }}
				</button>
			</div>
		</ng-container>
		<ng-container ngProjectAs="[right-buttons]">
			<div class="rx-intuitive-implants-view-modal__footer-actions">
				<button tlkButton variant="secondary" size="m" type="button" (click)="handleDismiss()">
					{{ 'NotesSection.Cancel' | translate }}
				</button>
				<button
					*ngIf="(isReadOnly$ | async) !== true"
					tlkButton
					variant="primary"
					size="m"
					type="button"
					(click)="handleSaveAndClose()"
				>
					{{ 'NotesSection.Save' | translate }}
				</button>
			</div>
		</ng-container>
	</tlk-modal-footer>
</div>
